import Association from '@/components/lawyer/Association1'
import Lawyer from '@/components/lawyer/Lawyer'
import Period from '@/components/lawyer/Period'
import Record from '@/components/lawyer/period/Period'
import Credit from '@/components/lawyer/Credit'
import Check from '@/components/lawyer/Check'

let lawyer = [{
  path: '/lawyer/association',
  name: 'Association',
  component: Association
},{
  path: '/lawyer/lawyer',
  name: 'Lawyer',
  component: Lawyer
},{
  path: '/lawyer/period',
  name: 'Period',
  component: Period
},{
  path: '/lawyer/credit',
  name: 'Credit',
  component: Credit
},{
  path: '/lawyer/record',
  name: 'Record',
  component: Record
},{
  path: '/lawyer/check',
  name: 'Check',
  component: Check
}]

export default lawyer



// WEBPACK FOOTER //
// ./src/router/lawyer.js